var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content-title"},[_c('p',[_vm._v(_vm._s(_vm.contents.articleName))]),_c('p',[_vm._v(_vm._s(_vm.contents.summary))])]),_c('p',{staticClass:"hr"}),_c('div',{staticClass:"contentView"},[_c('div',{staticClass:"content contentsy",domProps:{"innerHTML":_vm._s(_vm.contents.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }